import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './GridItem.css';

const GridItem = ({ item }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (item.postId) {
      // 피드 페이지로 이동하면서 바로 모달 열기
      // 현재 경로를 state로 저장하여 모달 닫을 때 돌아올 수 있도록
      navigate(`/feed?modal=${item.postId}&slide=${item.mediaIndex || 0}`, {
        state: { from: location.pathname }
      });
    }
  };

  return (
    <div className="grid-item" onClick={handleClick}>
      <img
        src={item.thumbnailUrl}
        alt="thumbnail"
        className="grid-item-image"
        loading="lazy"
      />
      {item.mediaType === 'VIDEO' && (
        <div className="video-indicator">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default GridItem;

